import { createImg } from "../../../DomUtilities/ElementsCreator";
import Service from "../../../Models/Service";
import Mediator from "../../../Utilities/Mediator";
import DescriptionModal from "./Modals/DescriptionModal";
import OrderHandler from "../OrderHandler";
import ChooseVariant from "./ChooseVariant";

export default class ServiceTile {
	service: Service;
	serviceTile: HTMLDivElement;
	descriptionIcon: HTMLElement;
	descriptionModal: DescriptionModal;
	serviceCost: HTMLParagraphElement;

	constructor(serviceObject: Service) {
		this.service = serviceObject; //service with all variants
		this.descriptionModal = new DescriptionModal();

		this.init();
	}

	private init() {
		this.createServiceTile();
		this.addServiceClickListener();
		this.addDescriptionModalClickListener();

		Mediator.on("serviceCostChanged", (serviceId: string, cost: number) => {
			if (serviceId === this.service.id) {
				if (cost >= 0) {
					this.serviceCost.innerText = `${cost} DKK`;
				} else {
					if (OrderHandler.selectedItem.services.length === 0) {
						Mediator.emit("serviceRemoved");
					}
					this.serviceCost.innerText = "";
					this.serviceTile.classList.remove("--selected");
				}
			}
		});
	}

	private createServiceTile() {
		this.serviceTile = document.createElement('div');
		this.descriptionIcon = document.createElement('i');
		const src: string = this.service.image ? this.service.image : "/assets/no_image_placeholder.png";
		const icon = createImg(src, `${this.service.name} ikon`);
		const iconWrapper = document.createElement('div');
		const name = document.createElement('h5');

		this.serviceTile.id = this.service.id;
		this.serviceTile.title = this.service.name;
		this.descriptionIcon.classList.add('icon-info-sign');
		iconWrapper.appendChild(icon);
		this.serviceCost = document.createElement('p');

		if (OrderHandler.selectedItem.hasSimpleOrderFlow) {
			this.serviceCost.classList.add("simple-service");
			this.serviceCost.innerText = `${this.service.variants[0].cost} DKK`;
		}

		name.innerText = this.service.name;

		this.serviceTile.appendChild(this.descriptionIcon);
		this.serviceTile.appendChild(iconWrapper);
		this.serviceTile.appendChild(name);
		this.serviceTile.appendChild(this.serviceCost);

		if (OrderHandler.selectedItem.services.some(s => s.id === this.service.id && s.variants.length > 0)) {
			this.serviceTile.classList.add("--selected");
			if (this.service.variants.length == 1)
				this.serviceCost.innerHTML = `${this.service.variants[0].cost} DKK`;
		}
	}

	private addServiceClickListener() {
		this.serviceTile.onclick = () => {
			this.selectService();
		}
	}

	private selectService() {
		this.serviceTile.classList.add("--selected");
		let index: number = OrderHandler.selectedItem.services.findIndex(s => s.id == this.service.id);
		if (index == -1) {
			this.addService();
		}
		new ChooseVariant(this.service);
	}

	private addService() {
		let service = new Service();
		service.id = service.serviceTypeId = this.service.id;
		service.name = this.service.name;
		service.type = this.service.type;
		service.descriptions = this.service.descriptions;
		service.image = this.service.image;
		service.itemId = OrderHandler.selectedItem.itemId;
		OrderHandler.selectedItem.services.push(service);
	}

	private addDescriptionModalClickListener() {
		this.descriptionIcon.onclick = (event: MouseEvent) => {
			event.stopPropagation();
			const text = this.service.descriptions.find(d => d)?.text;
			const image = this.service.descriptions.find(d => d)?.image;
			this.descriptionModal.openModal(text, image);
		}
	}
}
